// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/volcanic-ash.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/volcanic-ash/volcanic-ash.js';

mount([g0]);
